import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "../../../Common/Loader/loader";
import { innergetVehicleReport } from "../../../Apis/satReportsApi";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import { GetZone } from "../../../Apis/organizationApi";
import { Formik, Form, Field } from "formik";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { Modal } from "react-bootstrap";
import { formattedDate, getCurrentDateTime1, getCurrentISTDate } from "../../../Common/helper/helpar";
import useFilterStore from "./store/useFilterStore";

const ReportedAtWardNotTSCircle = () => {
  const { circleWiseFilters } = useFilterStore();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [zoneName, setZoneName] = useState("");
  const location = useLocation();
  const { data, fromDate } = location.state;
  const [gvpList, setGvpList] = useState(data);
  const [zonesData, setZonesData] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);

  const vehicleReportColumns = [
    {
      name: "S.No",
      selector: (row) => row["slno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
      width: "70px",
    },
    {
      name: "Zone",
      selector: (row) => row["zoneName"],
      cell: (row) => <span>{row["zoneName"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: "Circle",
      selector: (row) => row["circleName"],
      cell: (row) => <span>{row["circleName"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: "Ward",
      selector: (row) => row["wardName"],
      cell: (row) => <span>{row["wardName"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Vehicle Type</>,
      selector: (row) => row["vehicleTypeName"],
      cell: (row) => <span>{row["vehicleTypeName"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Owner Type</>,
      selector: (row) => row["ownerTypeName"],
      cell: (row) => <span>{row["ownerTypeName"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Vehicle Number</>,
      selector: (row) => row["vehicleNumber"],
      cell: (row) => <span>{row["vehicleNumber"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Driver Name</>,
      selector: (row) => row["driverName"],
      cell: (row) => <span>{row["driverName"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Driver Number</>,
      selector: (row) => row["mobileNumber"],
      cell: (row) => <span>{row["mobileNumber"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>SFA Name</>,
      selector: (row) => row["primaryDeploymentInchargeName"],
      cell: (row) => <span>{row["primaryDeploymentInchargeName"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>SFA Number</>,
      selector: (row) => row["sfaMobileNumber"],
      cell: (row) => <span>{row["sfaMobileNumber"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Scanned Date</>,
      selector: (row) => row["deploymentDate"],
      cell: (row) => <span>{row["deploymentDate"] || "N/A"}</span>,
      sortable: true,
      width: "125px",
    },
    {
      name: <>Latitude</>,
      selector: (row) => row["scannedLatitude"],
      cell: (row) => <span>{row["scannedLatitude"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Longitude</>,
      selector: (row) => row["scannedLongitude"],
      cell: (row) => <span>{row["scannedLongitude"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: "Vehicle Image",
      cell: (row) => {
        if (row["vehicleImageUrl"]) {
          return (
            <img
              src={row["vehicleImageUrl"]}
              alt="Vehicle"
              style={{ width: "100px", height: "50px", objectFit: "cover", borderRadius: "10px", cursor: "pointer" }}
              onClick={() => handleImageClick(row.vehicleImageUrl)}
            />
          );
        } else {
          return <span>No image</span>;
        }
      },
      sortable: true,
      width: "120px",
    },
  ];

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowImageModal(true);
  };

  const handleClose = () => {
    setShowImageModal(false);
    setSelectedImage(null);
  };

  useEffect(() => {
    const fetchZoneName = async () => {
      try {
        const zoneData = await GetZone();
        const zoneIdFromLocalStorage = localStorage.getItem("zoneId");
        const zoneNamesDictionary = {};

        zoneData.forEach((zone) => {
          zoneNamesDictionary[zone.zoneId] = zone.zoneName;
        });

        const zoneName = zoneNamesDictionary[zoneIdFromLocalStorage];
        setZoneName(zoneName);
      } catch (error) {
        console.error("Error fetching zone name:", error);
      }
    };

    fetchZoneName();
  }, []);

  useEffect(() => {
    fetchData();
    // Apply default filter on load
    const defaultValues = getDefaultFilterFields();
    searchReportedAtVehicleHandler(defaultValues);
  }, []);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await innergetVehicleReport();
      setZonesData(response);
    } catch (error) {
      console.error("Error fetching Vehicle wise report:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const downloadAsExcel = async () => {
    const currentDate = new Date();
    const formattedDates = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Circle Wise At Ward But Not TS Report as on ${fromDate ? formattedDate(fromDate) : getCurrentISTDate()} (at ${getCurrentDateTime1()})`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    const boldFont = { bold: true };

    const downloadDateTime = `Reported on: ${formattedDates} ${formattedTime}`;
    const dateTimeRow = worksheet.addRow(["", "", downloadDateTime, "", ""]);
    worksheet.mergeCells(1, 3, 1, 5);
    dateTimeRow.getCell(3).font = boldFont;
    dateTimeRow.getCell(3).alignment = { horizontal: "center" };
    dateTimeRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 5) {
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    const cumulativeHeadingRow = worksheet.addRow(["", "", cumulativeHeadingReport, "", ""]);
    worksheet.mergeCells(2, 3, 2, 5);
    cumulativeHeadingRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 5) {
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    worksheet.addRow([""]);

    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone",
      "Circle",
      "Ward",
      "Vehicle Type",
      "Owner Type",
      "Vehicle Number",
      "Driver Name",
      "Driver Number",
      "SFA Name",
      "SFA Number",
      "Deployment Date",
      "Latitude",
      "Longitude",
      // "Vehicle Image",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 15) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" },
        };
      }
    });

    gvpList.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.zoneName ?? "N/A",
          item.circleName ?? "N/A",
          item.wardName ?? "N/A",
          item.vehicleTypeName ?? "N/A",
          item.ownerTypeName ?? "N/A",
          item.vehicleNumber ?? "N/A",
          item.driverName ?? "N/A",
          item.mobileNumber ?? "N/A",
          item.primaryDeploymentInchargeName ?? "N/A",
          item.sfaMobileNumber ?? "N/A",
          item.deploymentDate || "N/A",
          item.scannedLatitude || "N/A",
          item.scannedLongitude || "N/A",
          // item.vehicleImageUrl ? "Image Available" : "No Image",
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 15) {
            cell.alignment = { horizontal: "left" };
          } else {
            cell.alignment = { horizontal: "center" };
          }
        });
    });

    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 23 },
      { width: 23 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 25 },
      { width: 25 },
      { width: 20 },
      { width: 23 },
      { width: 20 },
      { width: 20 },
    ];

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "CircleWiseAtWardButNotTSReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  const getDefaultFilterFields = () => {
    const baseDate = fromDate ? new Date(fromDate) : new Date();
    if (isNaN(baseDate.getTime())) {
      baseDate = new Date();
    }
    const fromDateTime = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate(), 0, 0);
    const now = new Date();
    const toDateTime = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate(), now.getHours(), now.getMinutes());

    const formatDateTime = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    return {
      searchZone: "",
      searchCircle: "",
      searchVehicleNumber: "",
      searchSFAIncharge: "",
      searchFromDate: formatDateTime(fromDateTime),
      searchToDate: formatDateTime(toDateTime),
    };
  };

  const parseDeploymentDate = (dateString) => {
    if (!dateString || dateString === "N/A") return null;
    const [datePart, timePart] = dateString.split(" ");
    if (!datePart || !timePart) return null;
    const [day, month, year] = datePart.split("-").map(Number);
    const date = new Date(year, month - 1, day, ...timePart.split(":").map(Number));
    return isNaN(date.getTime()) ? null : date;
  };

  const searchReportedAtVehicleHandler = (values) => {
    const termZone = values.searchZone ? values.searchZone.toLowerCase() : "";
    const termCircle = values.searchCircle ? values.searchCircle.toLowerCase() : "";
    const termVehicleNumber = values.searchVehicleNumber ? values.searchVehicleNumber.toLowerCase() : "";
    const termSFAIncharge = values.searchSFAIncharge ? values.searchSFAIncharge.toLowerCase() : "";
    const termFromDate = values.searchFromDate ? new Date(values.searchFromDate) : null;
    const termToDate = values.searchToDate ? new Date(values.searchToDate) : null;

    const filteredData = data.filter((item) => {
      const zoneName = item?.zoneName ? item.zoneName.toLowerCase() : "";
      const circleName = item?.circleName ? item.circleName.toLowerCase() : "";
      const vehicleNumber = item?.vehicleNumber ? item.vehicleNumber.toLowerCase() : "";
      const SFAIncharge = item?.primaryDeploymentInchargeName ? item.primaryDeploymentInchargeName.toLowerCase() : "";
      const SFAInchargeNumber = item?.sfaMobileNumber ? item.sfaMobileNumber.toString() : "";
      const deploymentDate = parseDeploymentDate(item?.deploymentDate);

      const matchesZone = !termZone || zoneName.includes(termZone);
      const matchesCircle = !termCircle || circleName.includes(termCircle);
      const matchesVehicleNumber = !termVehicleNumber || vehicleNumber.includes(termVehicleNumber);
      const isNumber = /^[0-9]+$/.test(termSFAIncharge);
      const matchesSFA =
        !termSFAIncharge ||
        SFAIncharge.includes(termSFAIncharge) ||
        (isNumber && SFAInchargeNumber.includes(termSFAIncharge));
      const matchesDate =
        !deploymentDate ||
        (!termFromDate && !termToDate) ||
        (termFromDate && !termToDate && deploymentDate >= termFromDate) ||
        (!termFromDate && termToDate && deploymentDate <= termToDate) ||
        (termFromDate && termToDate && deploymentDate >= termFromDate && deploymentDate <= termToDate);

      return matchesZone && matchesCircle && matchesVehicleNumber && matchesSFA
      //  && matchesDate;
    });

    setGvpList(filteredData);
  };

  const handleReset = () => {
    const defaultValues = getDefaultFilterFields();
    searchReportedAtVehicleHandler(defaultValues);
    const form = document.getElementById("filterForm");
    form.reset();
    form.dispatchEvent(new Event("reset"));
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="card">
                <div className="card-body">
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "1rem",
                      marginTop: "1rem",
                    }}
                  >
                    <div style={{ width: "85%" }}>
                      <Formik initialValues={getDefaultFilterFields()}>
                        {({ handleChange, values }) => (
                          <Form id="filterForm">
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "1rem",
                              }}
                            >
                              <div >
                                <div className="form-group">
                                  <Field
                                    name="searchZone"
                                    placeholder="Search Zone"
                                    type="text"
                                    className="form-control bg-white"
                                    style={{ width: "100%" }}
                                    onInput={(e) => {
                                      handleChange(e);
                                      searchReportedAtVehicleHandler({
                                        ...values,
                                        searchZone: e.target.value,
                                      });
                                    }}
                                  />
                                </div>
                              </div>
                              <div >
                                <div className="form-group">
                                  <Field
                                    name="searchCircle"
                                    placeholder="Search Circle"
                                    type="text"
                                    className="form-control bg-white"
                                    style={{ width: "100%" }}
                                    onInput={(e) => {
                                      handleChange(e);
                                      searchReportedAtVehicleHandler({
                                        ...values,
                                        searchCircle: e.target.value,
                                      });
                                    }}
                                  />
                                </div>
                              </div>
                              <div >
                                <div className="form-group">
                                  <Field
                                    name="searchVehicleNumber"
                                    placeholder="Search Vehicle Number"
                                    type="text"
                                    className="form-control bg-white"
                                    style={{ width: "100%" }}
                                    onInput={(e) => {
                                      handleChange(e);
                                      searchReportedAtVehicleHandler({
                                        ...values,
                                        searchVehicleNumber: e.target.value,
                                      });
                                    }}
                                  />
                                </div>
                              </div>
                              <div >
                                <div className="form-group" title="Search SFA Incharge Name or Number">
                                  <Field
                                    name="searchSFAIncharge"
                                    placeholder="Search SFA Incharge Name or Number"
                                    type="text"
                                    className="form-control bg-white"
                                    style={{ width: "100%" }}
                                    onInput={(e) => {
                                      handleChange(e);
                                      const searchValue = e.target.value.trim();
                                      const isNumber = /^[0-9]+$/.test(searchValue);
                                      searchReportedAtVehicleHandler({
                                        ...values,
                                        searchSFAIncharge: searchValue,
                                        searchBy: isNumber ? "number" : "name",
                                      });
                                    }}
                                  />
                                </div>
                              </div>
                              {/* <div >
                                <div className="form-group">
                                  <Field
                                    name="searchFromDate"
                                    placeholder="From Date and Time"
                                    type="datetime-local"
                                    className="form-control bg-white"
                                    style={{ width: "100%" }}
                                    onInput={(e) => {
                                      handleChange(e);
                                      searchReportedAtVehicleHandler({
                                        ...values,
                                        searchFromDate: e.target.value,
                                      });
                                    }}
                                  />
                                </div>
                              </div>
                              <div >
                                <div className="form-group">
                                  <Field
                                    name="searchToDate"
                                    placeholder="To Date and Time"
                                    type="datetime-local"
                                    className="form-control bg-white"
                                    style={{ width: "100%" }}
                                    onInput={(e) => {
                                      handleChange(e);
                                      searchReportedAtVehicleHandler({
                                        ...values,
                                        searchToDate: e.target.value,
                                      });
                                    }}
                                  />
                                </div>
                              </div> */}
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </div>
                    <div
                      style={{
                        width: "15%",
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "0.5rem",
                        alignItems: "center",
                      }}
                    >
                      <button
                        className="btn btn-secondary"
                        style={{ padding: "0.375rem 0.75rem", fontSize: "0.875rem" }}
                        onClick={() => navigate(-1, { state: { data, fromDate } })}
                      >
                        Back
                      </button>
                      <button
                        className="btn btn-excel"
                        style={{ padding: "0.375rem 0.75rem", fontSize: "0.875rem" }}
                        onClick={downloadAsExcel}
                      >
                        <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                      </button>
                    </div>
                  </div>

                  <div className="top-header">
                    <span>
                      SATs Circle Wise Reported At Ward Not TS as on {fromDate ? formattedDate(fromDate) : getCurrentISTDate()} (at {getCurrentDateTime1()})
                    </span>
                  </div>

                  <CustomDataTable
                    data={gvpList}
                    columns={vehicleReportColumns}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
      <Modal show={showImageModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Image Full Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img
            src={selectedImage}
            alt="Full vehicle"
            style={{ width: "100%", height: "400px", borderRadius: "5px", objectFit: "contain" }}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ReportedAtWardNotTSCircle;